import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'brand_catalog_completeness-out_of_stock_product_tile_control-action_category_click';

/**
 * This event is emitted when there is a click on an Out of Stock product tile on the brand shop page for the control group old experience.
 */
export function trackBrandCatalogCompletenessOutOfStockProductTileControlActionCategoryClick(
  retailerToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { retailerToken },
  });
}
